module.exports = __webpack_public_path__ + "media/images/reseller-cover-47c7e97a.jpg";